<template lang="pug">
  .legend__group
    .legend__type
      label.legend__switch.switch
        span.semibold.legend__name Поиск
        input.visually-hidden.switch__input(type="checkbox" v-model="showSearch" @change="clearSearchResult")
        span.switch__block
    div(v-if="showSearch")
      .legend__group
        .legend__type
          .semibold.legend__name
            span Поиск по наименованию и адресу отходообразователей
        .legend__small-group
          e-suggestion.search.geo__search(
            placeholder=" "
            :suggestionEndpoint="garbageSuggestionEndpoint"
            :transformSuggestions="transformSuggestions"
            @selectItem="selectGarbageOnMapSearch"
            @clear="clearCurrentSearchResults(searchGarbageLayer)"
            name="garbageSearch"
            :model="suggestionMapSearch"
            :useInnerSearch="false"
            :addInfo="true"
            :addBorder="true"
          )
      .legend__group
        .legend__type
          .semibold.legend__name
            span Поиск по наименованию и адресу объекта обращения
        .legend__small-group
          e-suggestion.search.geo__search(
            placeholder=" "
            :suggestionEndpoint="tkoObjectsSuggestionEndpoint"
            :transformSuggestions="transformSuggestions"
            @selectItem="selectTkoObjectOnMapSearch"
            @clear="clearCurrentSearchResults(searchTkoObjectLayer)"
            name="tkoObjectSearch"
            :model="suggestionMapSearch"
            :useInnerSearch="false"
            :addInfo="true"
            :addBorder="true"
          )
      .legend__group
        .legend__type
          .semibold.legend__name
            span Поиск по наименованию и адресу мест накопления отходов
        .legend__small-group
          e-suggestion.search.geo__search(
            placeholder=" "
            :suggestionEndpoint="msnSuggestionEndpoint"
            :transformSuggestions="transformSuggestions"
            @selectItem="selectMsnOnMapSearch"
            @clear="clearSearchResult"
            name="msnSearch"
            :model="suggestionMapSearch"
            :useInnerSearch="false"
            :addInfo="true"
            :addBorder="true"
          )
      .legend__group
        .legend__type
          .semibold.legend__name
            span Поиск по наименованию населенного пункта
        .legend__small-group
          e-suggestion.search.geo__search(
            placeholder=" "
            :suggestionEndpoint="atuSuggestionEndpoint"
            @selectItem="selectAtuOnMapSearch"
            @clear="clearSearchResult"
            name="atuSearch"
            :model="suggestionMapSearch"
            :useInnerSearch="false"
            :addInfo="true"
            :addBorder="true"
          )
</template>

<script>
import { map as mapEndpoints, atu } from '@/api/api-endpoints'
import geoSearchMixin from '../mixins/geo-search-mixin'

export default {
  name: 'map-search-fields',
  mixins: [geoSearchMixin],
  props: {
    map: {
      type: Object,
    },
    year: {
      type: Number,
    },
  },
  methods: {
    garbageSuggestionEndpoint(ctx, q) {
      return mapEndpoints.source(null, { query: { name: q, address: q } })
    },
    tkoObjectsSuggestionEndpoint(ctx, q) {
      return mapEndpoints.tkoObjects({ query: { name: q, address: q } })
    },
    msnSuggestionEndpoint(ctx, q) {
      return mapEndpoints.msn(null, { query: { name: q, address: q } })
    },
    atuSuggestionEndpoint(ctx, q) {
      return atu.atuObjects({
        query: { q },
      })
    },
    transformSuggestions(ctx, data) {
      return Object.values(data).flat()
    },
  },
}
</script>

<style lang="scss">
.geo {
  &__search {
    .input {
      padding-left: 30px;
    }
  }
}
</style>
